import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import styles from './index.module.css'
import DetailTip from 'views/mydata/common/DetailTip';

const HomeMain = () => {

	const App = useApp()
	const [detailTip, setDetailTip] = useState(false)

	const openDetail = () => {
		setDetailTip(true)
	}

	const closeDetail = () => {
		setDetailTip(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding pb_50">
					<div className="flex-justify_between align_center">
						<h3>내 집 보기</h3>
						<span className={styles["add-btn"]}>+ 추가</span>
					</div>
					<div className={`${styles["m-title"]} flex-align_center mt_40`}>
						<p>총 자산 금액</p>
						<i className="icon icon_question ml_10" onClick={openDetail} />
					</div>
					<div className={`${styles["price-lg"]} mt_10`}><strong>1,218,000,000</strong> 원</div>
				</div>
			</div>
			<ul className="estate-list list-bg pb_40">
				<li>
					<p>에이치스퀘어 N차</p>
					<div className="flex-justify_between align_center">
						<div className="estate-info">
							<span>오피스텔</span>
							<span>매매</span>
						</div>
						<strong>7억 4,000만원</strong>
					</div>
				</li>
				<li>
					<p>에이치스퀘어 N차</p>
					<div className="flex-justify_between align_center">
						<div className="estate-info">
							<span>아파트</span>
							<span>전세</span>
						</div>
						<strong>1,230만원</strong>
					</div>
				</li>
				<li>
					<p>에이치스퀘어 N차</p>
					<div className="flex-justify_between align_center">
						<div className="estate-info">
							<span>연립/다세대</span>
							<span>월세</span>
						</div>
						<strong>1,000만원</strong>
					</div>
				</li>
				<li>
					<p>에이치스퀘어 N차</p>
					<div className="flex-justify_between align_center">
						<div className="estate-info">
							<span>아파트</span>
							<span>매매</span>
						</div>
						<strong>4억 7,800만원</strong>
					</div>
				</li>
			</ul>

			{/* 데이터 없을 때 */}
			<div className="padding">
				<div className="center-cont no-data-box py_40">
					<i className="icon icon_no_data" />
					<p className="mt_20">등록한 부동산이 없습니다.<br />내 집을 등록하고 시세를 알아보세요.</p>
				</div>
			</div>

			<DetailTip show={detailTip} closeLayer={closeDetail} title="총 자산 금액" content="내 집 보기의 총 자산 금액은 매매 금액, 전세의 보증금 및 월세의 보증금을 더한 금액이에요." />
		</div>
	)
}

export default HomeMain